import styled from 'styled-components'
import {
  darkAccent,
  gray97,
  lightgrey,
  lightText,
} from '../../../../../../../../../Styles/colors'
import { hFlex, vFlex } from '../../../../../../../../../Styles/style-helpers'

export const BatchesEl = styled.div`
  ${vFlex};
  width: 30em;
  height: 100%;
  justify-content: flex-start;
  padding-right: 1em;

  .searchBox {
    width: 100%;
    padding: 0 1em;

    .inputWrapper {
      margin: 1em 0 0;
    }

    .search {
      ${vFlex};
      border: 1px solid ${lightgrey};
      border-radius: 6px;
      padding: 0.75em 1em;

      &:not(:placeholder-shown) + .placeholder,
      &:focus + .placeholder {
        font-size: 1em;
        padding: 0 0 0 1em;
        opacity: 0;
        transform: translate(0, -50%);
      }
    }

    .placeholder {
      ${vFlex};
      color: ${lightText};
      padding: 0.85em 1em;
      transition: all 50ms ease;
      font-size: 1em;
      align-items: baseline;

      &.active {
        opacity: 0;
      }
    }
  }

  .batches-list {
    ${vFlex};
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    padding: 0 1em;

    > a {
      width: 100%;
    }

    .filterBox {
      width: 100%;
      ${hFlex};
      justify-content: flex-end;
      margin: 1em 0;
      transform-origin: 100% 50%;

      .inputWrapper {
        width: 50%;
        margin: 0;
      }
    }
  }
`

export const BatchTabEl = styled.div`
  ${hFlex};
  width: 100%;
  border-radius: 0.25em;
  margin: 0.5em 0;
  padding: 0.75em;
  background-color: ${({ isActive }) => (isActive ? gray97 : '')};
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.35);
  font-size: 0.9em;

  .info {
    height: 100%;
    padding-right: 0.25em;
    width: 100%;
    flex: 1;

    > * {
      margin: 0.2em 0;
    }

    h4 {
      font-weight: bold;
    }

    .stats {
      margin: 1em 0;
      line-height: 1.33;
      opacity: 0.66;
    }

    .progress-bar {
      width: 100%;
      background: rgba(0, 0, 0, 0.15);
      height: 3px;
      border-radius: 10em;
      overflow: hidden;
      line-height: 2;

      .progress {
        background-color: ${darkAccent};
        height: 100%;
        width: ${({ progress }) => progress}%;
        border-radius: 10em;
        overflow: hidden;
      }
    }
  }

  .nextClass {
    ${vFlex};
    padding: 0 1em;
    height: 100%;
    min-width: 30%;
    text-transform: capitalize;
  }
`
